<template>
    <div class="taxi-bill">
        <div class="taxi-bill-body">
            <div class="bill-body-top">
                <div class="bill-body-top-left">
                    <div>09:45</div>
                    <span>25/03</span>
                </div>
                <div class="bill-body-top-right">
                    <div class="point-of-departure">
                        <div class="address-icon">
                            <van-icon name="circle"/>
                        </div>
                        <div class="detailed-address">
                            <div class="detailed-address-ac">57 rue de jean</div>
                            <div class="detailed-address-nc">92100,Bludgeon-Bill</div>
                        </div>
                    </div>
                    <div class="to-destination">
                        <div class="address-icon">
                            <van-icon name="location"/>
                        </div>
                        <div class="detailed-address">
                            <div class="detailed-address-ac">2 rue de tilleuls</div>
                            <div class="detailed-address-nc">92100,Bludgeon-Bill</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bill-body-middle">
                <div class="bill-round-left"></div>
                <div class="bill-round-middle"></div>
                <div class="bill-round-right"></div>
            </div>
            <div class="bill-body-bottom">
                <div>预计价格 € 59</div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name:'TaxiBill',
    }
</script>
<style scoped>
   .taxi-bill{
       margin: 20px;
       background-color: #fff;
       border-radius: 10px;
       box-shadow: 0 13px 24px #ebedf0;
   }
   .taxi-bill-body{
       height: 100%;
   }
    .taxi-bill-line{
        height: 20px;
        position: relative;
        top: 60%;
        background: #d2d227;
    }
    .bill-body-middle div{
        display: inline-block;
    }
    .bill-round-left{
        height: 40px;
        width: 40px;
        border-radius: 20px;
        background: #ebedf0;
        position: relative;
        left: -20px;top: -13px;
    }
    .bill-round-right{
        height: 40px;
        width: 40px;
        float: right;
        background: #ebedf0;
        border-radius: 20px;
        position: relative;
        right: -20px;top: -13px;
    }
   .bill-body-middle{
       height: 15px;
       background: #cece66;
    }
    .bill-body-top{
        padding: 20px;
    }
    .bill-body-top-left{
        display: inline-block;
        width: 20%;float: left;
    }
   .bill-body-top-right{
       display: inline-block;width: 80%;
   }
    .bill-body-bottom{
        padding: 20px;
        text-align: center;
        font-size: 1.2rem;
        font-weight: 600;
    }
    .address-icon{
        display: inline-block;
        float: left;padding: 0 3px;
    }
    .detailed-address{
        display: inline-block;width: 90%;
    }
    .detailed-address div{
        word-wrap:break-word;
        word-break:normal;
    }
    .bill-body-top-left div{
        font-size: 1.2rem;
    }
   .bill-body-top-left span{
       font-size: 0.8rem;
       color: #999;
   }
    .point-of-departure{
        padding-bottom: 20px;
    }
    .detailed-address-ac{
        font-size: 1.2rem;
    }
    .detailed-address-nc{
        color: #999;
    }
</style>